<div class="slider-vertical-container">
  <div class="slider-vertical" (click)="onTrackClick($event)">
    <!-- the lightly-shaded track -->
    <div class="track"></div>
  
    <!-- ticks at 0..5 -->
    <ng-container *ngFor="let tick of ticks; let i = index">
      <div class="tick"
      [class.bottom-tick]="i === 0"
      [class.top-tick]="i === ticks.length - 1"
       [style.bottom.%]="(i/5)*100"></div>
    </ng-container>
  
    <!-- the draggable icon thumb -->
    <div class="handle" [style.bottom.%]="(value/5)*100">
      <!-- replace with your icon system -->
      <i class="material-icons">{{ icon }}</i>
    </div>
  </div>

  <div class="slider-vertical-label" [innerHTML]="name.split(' ').join('<br/>')"></div>

</div>